import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'
type FactorsProps = {
  id: string
}
export const fetchFactors = ({ id }: FactorsProps) => {
  return new ServicesUseCase(
    `/aplicacaoTeste/loadFatores/${id}`,
    makeAxiosHttpClient()
  )
}
